export default function() {
	$(document).on('click', '.js-scroll2anchor', function(){
		const $this = $(this);
		const $target = $(`[data-scroll-target="${$this.attr('data-scroll-to')}"]`);
		const offset = $this.attr('data-scroll-offset') ? $this.attr('data-scroll-offset') : 0;
		if ($target.length) {
			$('html, body').animate({
				scrollTop: $target.offset().top - offset
			}, 800);
		} else if ($this.attr('data-link')) {
			window.location.href = $this.attr('data-link');
		}
	});
}
